import React, { useState } from 'react';
import { Layout } from '../ui/templates';
import { PageNotFound } from '@/ui/templates/PageNotFound';
import { TemplateType, useLayoutData } from '@/api/tax-guide';
import LoadingShimmer from './LoadingShimmer';
import { TaxGuideContextProvider } from '@/state/TaxGuideProvider';
import { TaxGuideContent } from '@/ui/templates/TaxGuideContent';
import InputSection from '@/ui/molecules/InputSection/InputSection';
import { SiteMaintenanceComponent } from '@/ui/templates/SiteMaintenance';

export const TaxGuide = (props: {
  userId: string;
  templateType: TemplateType;
  ad: 1 | null;
}) => {
  const [showBottomBanner, setBottomBanner] = useState(false);
  const { userId, templateType, ad } = props;

  const { data: layoutResponse, isLoading } = useLayoutData(
    userId,
    templateType,
    ad,
  );

  if (isLoading) return <LoadingShimmer call="full" />;
  if (!layoutResponse?.data) return <SiteMaintenanceComponent />;
  if (!layoutResponse?.data?.layout) return <PageNotFound />;

  const {
    layout: { disclaimer, bannerTop, bannerBottom },
    folderName,
    companyName,
    companyId,
    id: directLoginId,
    languages,
  } = layoutResponse.data;

  document.title = companyName ? `${companyName} - Tax Guide` : 'Tax Guide';

  return (
    <Layout
      header={{
        bannerTopHTML: bannerTop,
        bannerBottomHTML: bannerBottom,
        showBottomBanner: showBottomBanner,
      }}
      footer={{
        disclaimerContent: disclaimer,
      }}
      folderName={folderName}
      template={templateType}
    >
      <TaxGuideContextProvider
        companyId={companyId}
        directLoginId={directLoginId}
        language={languages?.[0]?.id}
        templateType={templateType}
      >
        <InputSection
          layoutData={layoutResponse.data}
          template={templateType}
          setBottomBanner={setBottomBanner}
        />
        <TaxGuideContent />
      </TaxGuideContextProvider>
    </Layout>
  );
};
